import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    @Input() username: string;
    @Output() public onLogoutClicked: EventEmitter<void>;

    constructor() {
        this.onLogoutClicked = new EventEmitter<void>();
    }

    ngOnInit(): void {
    }

    public logout(): void {
        this.onLogoutClicked.emit();
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/header/header.component.ts